import { jsx as m } from "react/jsx-runtime";
import { useMemo as p } from "react";
import u from "@cubejs-client/core";
import { CubeProvider as a } from "@cubejs-client/react";
import { useAuth as b } from "@dcentralexpedientedigital/fe-shared/hooks/use-auth";
const A = ({
  config: s,
  children: i
}) => {
  var n;
  const { apiUrl: e, tenantId: o } = s, { auth: r } = b(), t = ((n = r == null ? void 0 : r.user) == null ? void 0 : n.access_token) ?? null, c = p(
    () => u(
      async () => t ? `Bearer ${t}` : "",
      {
        apiUrl: `${e}/cubejs-api/v1`,
        headers: {
          "X-Tenant-ID": o
        }
      }
    ),
    [e, o]
  );
  return /* @__PURE__ */ m(a, { cubeApi: c, children: i });
};
export {
  A as CubeApiProvider
};
